(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    function startReserveTimer(root) {
      var clock = root.querySelector('[data-cart-reserve-clock]');
      if (!clock) return;
      var duration = parseInt(root.getAttribute('data-duration'), 10) || 300;
      var storageKey = 'maris_cart_reserve_until';
      var now = Date.now();
      var until = parseInt(localStorage.getItem(storageKey) || '0', 10);
      if (!until || until <= now) {
        until = now + duration * 1000;
        localStorage.setItem(storageKey, String(until));
      }
      function fmt(s) {
        var m = Math.floor(s / 60);
        var r = s % 60;
        return (m < 10 ? '0' + m : m) + ':' + (r < 10 ? '0' + r : r);
      }
      function tick() {
        var remaining = Math.max(0, Math.floor((until - Date.now()) / 1000));
        clock.textContent = fmt(remaining);
        if (remaining <= 0) {
          until = Date.now() + duration * 1000;
          localStorage.setItem(storageKey, String(until));
        }
      }
      tick();
      setInterval(tick, 1000);
    }
    function init() {
      document.querySelectorAll('[data-cart-reserve-timer]').forEach(startReserveTimer);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('cart:refresh', init);
    document.addEventListener('cart:updated', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
